import React from 'react'
import PropTypes from 'prop-types'
import ExpandableSection from '../ExpandableSection'
import Collection from '../Collection'
import getField from '../../utilities/Data/getField'
import Post from '../../utilities/Data/Post'
import Thing from '../../utilities/Data/Thing'
import urlForPostEdit from '../../utilities/urlForPostEdit'
import entityTypes from '../../enums/entityTypes'
import styles from './Posts.icss'

class UserPosts extends React.Component {
	render() {
		const { userProfile, isOwnProfile, userProfilePosts, itemOwnByKey, kitOwnById, itemWantByKey, kitWantById } = this.props

		const createPost = () => this.props.appRedirect('/post/edit')

		const contextMenuItems = () => [
			isOwnProfile && {
				name: this.context.translate('Delete'),
				handler: post => this.props.postDelete({ postId: post.postId })
			},
			isOwnProfile && {
				name: this.context.translate('Edit'),
				handler: post => this.props.appRedirect(urlForPostEdit({ postId: post.postId, kitId: post.kit.kitId }))
			}
		].filter(val => !!val)

		return (
			<div>
				<ExpandableSection title={userProfilePosts ? this.context.translate('{posts|# - Post|# - Posts}', { posts: getField(userProfile, 'countPostsCreated') || 0 }) : this.context.translate('Posts')} defaultExpanded>
					<Collection
						items={userProfilePosts}
						{...Post.collectionProps}
						itemSubtitle={Post.tagSummary}
						contextMenuItems={post => contextMenuItems(post, { isCreator: true })}
						itemOnSelect={post => this.props.appRedirect(Post.collectionProps.itemHref(post))}
						renderWhenNoItems={Post.renderNoPosts(!!userProfilePosts, isOwnProfile ? createPost : undefined, isOwnProfile ? this.context.translate('No posts yet - Click here to create one') : <div className={styles.noPosts}>{this.context.translate('No posts')}</div>)}
						itemFollowSet={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.USER.type]: user => isFollowing => this.props.postFollowersSet({ uid: user.uid, isFollowing })
						}))}
						itemImageCover={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.USER.type]: true
						}))}
						itemOwn={Post.isOwned({ itemOwnByKey, kitOwnById })}
						itemWant={Post.isWanted({ itemWantByKey, kitWantById })}
						itemOwnSet={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.ITEM.type]: item => own => this.props.itemOwnSet({ own, item }),
							[entityTypes.KIT.type]: kit => own => this.props.kitOwnSet({ own, kit })
						}))}
						itemWantSet={Post.forPostMainTag(Thing.propertyGetter({
							[entityTypes.ITEM.type]: item => want => this.props.itemWantSet({ want, item }),
							[entityTypes.KIT.type]: kit => want => this.props.kitWantSet({ want, kit })
						}))}
					/>
				</ExpandableSection>
			</div>
		)
	}
}

UserPosts.contextTypes = {
	translate: PropTypes.func
}

UserPosts.propTypes = {
	appRedirect: PropTypes.func.isRequired,
	isOwnProfile: PropTypes.bool,
	userProfile: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	userProfilePosts: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	postDelete: PropTypes.func.isRequired,
	postFollowersSet: PropTypes.func.isRequired,
	itemOwnByKey: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	kitOwnById: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	itemWantByKey: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	kitWantById: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	itemOwnSet: PropTypes.func.isRequired,
	kitOwnSet: PropTypes.func.isRequired,
	itemWantSet: PropTypes.func.isRequired,
	kitWantSet: PropTypes.func.isRequired
}

UserPosts.defaultProps = {
	isOwnProfile: false,
	userProfile: undefined,
	userProfilePosts: undefined,
	itemOwnByKey: undefined,
	kitOwnById: undefined,
	itemWantByKey: undefined,
	kitWantById: undefined
}

export default UserPosts



// WEBPACK FOOTER //
// ./src/components/User/Posts.jsx